import { FE_COOKIE_API } from '@/helper/apiConstants'
import { loadState } from '@/utils/localStorage'

// uidx (localStorage) and the token cookie (server) should always agree on login state - either both present or both absent. If exactly one is present, the two auth signals have drifted apart.
export const isSessionMismatched = async (): Promise<boolean> => {
  const hasUidx = !!loadState('uidx')

  // Middleware already verified the cookie to let this page load, so a fully anonymous visitor (no uidx) can't reach here - skip the call.
  if (!hasUidx) return false

  try {
    const res = await fetch(FE_COOKIE_API, { method: 'GET' })
    const json = await res.json()
    const hasCookie = !!json?.cookies?.token
    return hasUidx !== hasCookie
  } catch {
    return false // fail open - don't block navigation on a network blip
  }
}
